'use client'

import { useTimerProgressBar } from '../../../hooks/useTimerProgressBar'

type TimerProgressBarProps = {
  duration: number
  isActive: boolean
  onComplete?: () => void
  reset: boolean
  totalCount: number
  currentIndex: number
  isManualMode: boolean
}

const TimerProgressBar = ({
  duration,
  isActive,
  onComplete,
  reset,
  totalCount,
  currentIndex,
  isManualMode,
}: TimerProgressBarProps) => {
  const { progressSegments, animationKey } = useTimerProgressBar({
    duration,
    isActive,
    onComplete,
    reset,
    totalCount,
    currentIndex,
    isManualMode,
  })

  return (
    <div className="timer-progress-bar">
      {progressSegments.map(({ fillPercentage, shouldAnimate }, index) => (
        <div key={index} className="timer-progress-bar__segment">
          <div
            key={shouldAnimate ? animationKey : 'static'}
            className="timer-progress-bar__fill"
            style={{
              width: `${fillPercentage}%`,
              transition: shouldAnimate ? `width ${duration}ms linear` : 'none',
            }}
          />
        </div>
      ))}
    </div>
  )
}

export default TimerProgressBar
